import Layout from '@/layout';
import CloudServerRouter from '../../../cloudserver/router/index';

export default CloudServerRouter(Layout, 'mobile');
